import { createContext } from "react";

export const HistoryVisitOrigin = createContext<string | null>(null);
